module.exports = __webpack_public_path__ + "assets/img/AIF-Australian-Institute-of-Fitness-Page-Resource-w720.3dda36e8.webp";